import { useCompetitions } from '@/api/hooks/useCompetitions'
import { AdminOnlyRoute } from '@/components/admin-only-route'
import { StateSwitcher } from '@/components/atoms/state-switcher'
import CompetitionForm from '@/components/forms/competition-form'
import PageLayout from '@/components/layout/page-layout'
import { CompetitionLeaderboard } from '@/components/organisms/competition-leaderboard'
import { useSetSidebarSubLabel } from '@/contexts/sidebar-sub-label-context'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_authenticated/competitions/$competitionId')({
  component: () => (
    <AdminOnlyRoute>
      <CompetitionPage />
    </AdminOnlyRoute>
  ),
})

function CompetitionPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { competitionId } = Route.useParams()
  const { data: competitions = [], isError, isLoading } = useCompetitions()
  const competition = competitions.find(candidate => candidate.id === competitionId)

  useSetSidebarSubLabel(`/competitions/${competitionId}`, competition?.title)

  return (
    <PageLayout
      title={competition?.title ?? t('navigation.competitions')}
      defaultTab="leaderboard"
      tabs={[
        {
          label: t('competitionsPage.leaderboardTab'),
          value: 'leaderboard',
          children: <CompetitionLeaderboard competitionId={competitionId} />,
        },
        {
          label: t('competitionsPage.settingsTab'),
          value: 'settings',
          children: (
            <StateSwitcher isError={isError} isLoading={isLoading}>
              {competition ? (
                <CompetitionForm
                  key={competition.id}
                  competition={competition}
                  onSuccess={() => navigate({ to: '/competitions' })}
                />
              ) : null}
            </StateSwitcher>
          ),
        },
      ]}
    />
  )
}
